<div class="notification" *ngIf="notification"  @notificationAnim>
  <p>{{notification}}</p>
</div>
